import { Link } from 'react-router-dom';
import { asset } from '../assets';
import { useContactForm } from '../components/ContactFormProvider';
import { Hero } from '../components/Hero';
import { OffersSection } from '../components/OffersSection';
import { ProductBrowser } from '../components/ProductBrowser';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { useLanguage } from '../components/LanguageProvider';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "INGAZ Print";

function Home() {
  const { openContact } = useContactForm();
  const { t } = useLanguage();
  usePageSetup({ title });

  return (
    <>
      <SiteHeader home />
        <main className="home-main">
          <Hero />
          <OffersSection />
          <section className="everything-section" id="services">
            <h2>{t('Everything handled for you', 'كل شيء يتم التعامل معه من أجلك')}</h2>
            <div className="features">
              <div className="feature-card">
                <div className="feature-icon"><img src={asset('assets/printing.svg')} alt="High quality printing" /></div>
                <div className="feature-text">
                  <div className="feature-title">{t('Digital Printing', 'الطباعة الرقمية')}</div>
                  <div className="feature-desc">{t('Color & Black', 'ألوان وأبيض وأسود')}</div>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><img src={asset('assets/scissors.svg')} alt="Finishing" /></div>
                <div className="feature-text">
                  <div className="feature-title">{t('Binding & finishing', 'التجليد والتشطيب')}</div>
                  <div className="feature-desc">{t('Professional options', 'خيارات احترافية')}</div>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><img src={asset('assets/lamination.svg')} alt="Packaging" /></div>
                <div className="feature-text">
                  <div className="feature-title">{t('Lamination', 'التغليف')}</div>
                  <div className="feature-desc">{t('Protective coating', 'طبقة حماية')}</div>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><img src={asset('assets/packaging.svg')} alt="Packaging" /></div>
                <div className="feature-text">
                  <div className="feature-title">{t('Packaging & white labeling', 'التعبئة والتغليف والعلامة البيضاء')}</div>
                  <div className="feature-desc">{t('Custom solutions', 'حلول مخصصة')}</div>
                </div>
              </div>
              <div className="feature-card">
                <div className="feature-icon"><img src={asset('assets/delivery.svg')} alt="Delivery" /></div>
                <div className="feature-text">
                  <div className="feature-title">{t('Door-to-door delivery', 'توصيل من الباب إلى الباب')}</div>
                  <div className="feature-desc">{t('Fast & reliable', 'سريع وموثوق')}</div>
                </div>
              </div>
            </div>
            <div className="features-cta">
              <button className="btn2"><span>{t('See all services', 'عرض جميع الخدمات')}</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></button>
            </div>
          </section>
          {/* Print with us */}
          <section className="print-section" id="products">
            <h2 data-en="Print with us" data-ar="اطبع معنا">Print with us</h2>
            <ProductBrowser>
              <Link to="/business-cards" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/image1.webp')} alt="Business Cards" /></div>
                  <div className="print-meta">
                    <h4 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h4>
                    <p data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</p>
                  </div>
                </div>
              </Link>
              <Link to="/flyer-product" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/image2.webp')} alt="Flyers" /></div>
                  <div className="print-meta">
                    <h4 data-en="Flyers" data-ar="النشرات">Flyers</h4>
                    <p data-en="High quality single or double sided" data-ar="جودة عالية من جانب واحد أو وجهين">High quality single or double sided</p>
                  </div>
                </div>
              </Link>
              <Link to="/leaflets" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/image3.webp')} alt="Leaflets" /></div>
                  <div className="print-meta">
                    <h4 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h4>
                    <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  </div>
                </div>
              </Link>
              <Link to="/brochures" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/image5.webp')} alt="Brochures" /></div>
                  <div className="print-meta">
                    <h4 data-en="Brochures" data-ar="الكتيبات">Brochures</h4>
                    <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing material</p>
                  </div>
                </div>
              </Link>
              <Link to="/posters" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/poster_hero_new.png')} alt="Posters printing" /></div>
                  <div className="print-meta">
                    <h4 data-en="Posters" data-ar="الملصقات">Posters</h4>
                    <p data-en="Large format poster printing" data-ar="طباعة ملصقات كبيرة الحجم">Large format poster printing</p>
                  </div>
                </div>
              </Link>
              <Link to="/catalogues" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/image7.webp')} alt="Catalogues" /></div>
                  <div className="print-meta">
                    <h4 data-en="Catalogues" data-ar="الكتالوجات">Catalogues</h4>
                    <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks</p>
                  </div>
                </div>
              </Link>
              <Link to="/menus" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/image8.webp')} alt="Menus" /></div>
                  <div className="print-meta">
                    <h4 data-en="Menus" data-ar="القوائم">Menus</h4>
                    <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  </div>
                </div>
              </Link>
              <Link to="/menus-single" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/menus_single.png')} alt="Menus - Single Sheet" /></div>
                  <div className="print-meta">
                    <h4 data-en="Menus - Single Sheet" data-ar="قوائم - ورقة واحدة">Menus - Single Sheet</h4>
                    <p data-en="Single page menu printing" data-ar="طباعة قوائم صفحة واحدة">Single page menu printing</p>
                  </div>
                </div>
              </Link>
              <Link to="/menus-folded" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/menus_folded.png')} alt="Menus - Single Folded Sheet" /></div>
                  <div className="print-meta">
                    <h4 data-en="Menus - Single Folded Sheet" data-ar="قوائم - ورقة مطوية واحدة">Menus - Single Folded Sheet</h4>
                    <p data-en="Folded menu printing" data-ar="طباعة قوائم مطوية">Folded menu printing</p>
                  </div>
                </div>
              </Link>
              <Link to="/menus-tent" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/menus_tent.png')} alt="Menus - Table Tent" /></div>
                  <div className="print-meta">
                    <h4 data-en="Menus - Table Tent" data-ar="قوائم - خيمة طاولة">Menus - Table Tent</h4>
                    <p data-en="Table tent menu printing" data-ar="طباعة قوائم خيمة الطاولة">Table tent menu printing</p>
                  </div>
                </div>
              </Link>
              <Link to="/invitations" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/image4.webp')} alt="Invitations" /></div>
                  <div className="print-meta">
                    <h4 data-en="Invitations" data-ar="الدعوات">Invitations</h4>
                    <p data-en="Premium card stock" data-ar="ورق كرتوني عالي الجودة">Premium card stock</p>
                  </div>
                </div>
              </Link>
              <Link to="/postcards" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="business">
                  <div className="print-image"><img src={asset('assets/image9.webp')} alt="Postcards" /></div>
                  <div className="print-meta">
                    <h4 data-en="Postcards" data-ar="البطاقات البريدية">Postcards</h4>
                    <p data-en="Premium postcard printing" data-ar="طباعة بطاقات بريدية فاخرة">Premium postcard printing</p>
                  </div>
                </div>
              </Link>
              <Link to="/letterheads" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image6.webp')} alt="Letterheads" /></div>
                  <div className="print-meta">
                    <h4 data-en="Letterheads" data-ar="أوراق رسمية">Letterheads</h4>
                    <p data-en="Professional stationery" data-ar="قرطاسية احترافية">Professional stationery</p>
                  </div>
                </div>
              </Link>
              <Link to="/envelopes-ready-made" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image10.webp')} alt="Envelopes (Ready Made)" /></div>
                  <div className="print-meta">
                    <h4 data-en="Envelopes (Ready Made)" data-ar="المظاريف (جاهزة)">Envelopes (Ready Made)</h4>
                    <p data-en="Various sizes available" data-ar="أحجام مختلفة متاحة">Various sizes available</p>
                  </div>
                </div>
              </Link>
              <Link to="/envelopes-customized" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image10.webp')} alt="Envelopes (Customized)" /></div>
                  <div className="print-meta">
                    <h4 data-en="Envelopes (Customized)" data-ar="المظاريف (مخصصة)">Envelopes (Customized)</h4>
                    <p data-en="Custom sizes and printing" data-ar="أحجام وطباعة مخصصة">Custom sizes and printing</p>
                  </div>
                </div>
              </Link>
              <Link to="/folders" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image11.webp')} alt="Folders" /></div>
                  <div className="print-meta">
                    <h4 data-en="Folders" data-ar="المجلدات">Folders</h4>
                    <p data-en="Professional presentation" data-ar="عرض احترافي">Professional presentation</p>
                  </div>
                </div>
              </Link>
              <Link to="/notebooks" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image12.webp')} alt="Notebooks" /></div>
                  <div className="print-meta">
                    <h4 data-en="Notebooks" data-ar="المفكرات">Notebooks</h4>
                    <p data-en="Branded and customized" data-ar="علامة تجارية ومخصصة">Branded and customized</p>
                  </div>
                </div>
              </Link>
              <Link to="/agendas" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/agendas.png')} alt="Agendas" /></div>
                  <div className="print-meta">
                    <h4 data-en="Agendas" data-ar="أجندات">Agendas</h4>
                    <p data-en="Custom printed agendas" data-ar="أجندات مطبوعة مخصصة">Custom printed agendas</p>
                  </div>
                </div>
              </Link>
              <Link to="/certificates" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image13.webp')} alt="Certificates" /></div>
                  <div className="print-meta">
                    <h4 data-en="Certificates" data-ar="الشهادات">Certificates</h4>
                    <p data-en="Professional certificates" data-ar="شهادات احترافية">Professional certificates</p>
                  </div>
                </div>
              </Link>
              <Link to="/id-cards" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image16.webp')} alt="ID Cards" /></div>
                  <div className="print-meta">
                    <h4 data-en="ID Cards" data-ar="بطاقات الهوية">ID Cards</h4>
                    <p data-en="Professional ID cards" data-ar="بطاقات هوية احترافية">Professional ID cards</p>
                  </div>
                </div>
              </Link>
              <Link to="/badges" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image14.webp')} alt="Badges" /></div>
                  <div className="print-meta">
                    <h4 data-en="Badges / Name Tags" data-ar="الشارات / بطاقات الأسماء">Badges / Name Tags</h4>
                    <p data-en="Professional badges and name tags" data-ar="شارات وبطاقات أسماء احترافية">Professional badges and name tags</p>
                  </div>
                </div>
              </Link>
              <Link to="/prescription-pads" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image15.webp')} alt="Prescription Pads" /></div>
                  <div className="print-meta">
                    <h4 data-en="Prescription Pads" data-ar="دفاتر الوصفات الطبية">Prescription Pads</h4>
                    <p data-en="Medical prescription pads" data-ar="دفاتر وصفات طبية">Medical prescription pads</p>
                  </div>
                </div>
              </Link>
              <Link to="/self-carbon-notebooks" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image17.webp')} alt="Self-Carbon Notebooks" /></div>
                  <div className="print-meta">
                    <h4 data-en="Self-Carbon Notebooks (NCR / Carbonless)" data-ar="دفاتر الكربون الذاتي (NCR / بدون كربون)">Self-Carbon Notebooks (NCR / Carbonless)</h4>
                    <p data-en="Carbonless copy notebooks" data-ar="دفاتر نسخ بدون كربون">Carbonless copy notebooks</p>
                  </div>
                </div>
              </Link>
              <Link to="/bookmarks" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="stationery">
                  <div className="print-image"><img src={asset('assets/image18.webp')} alt="Bookmarks" /></div>
                  <div className="print-meta">
                    <h4 data-en="Bookmarks" data-ar="المرابط">Bookmarks</h4>
                    <p data-en="Custom bookmarks" data-ar="مرابط مخصصة">Custom bookmarks</p>
                  </div>
                </div>
              </Link>
              <Link to="/kraft-paper-bags" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="packaging">
                  <div className="print-image"><img src={asset('assets/image19.webp')} alt="Kraft Paper Bags" /></div>
                  <div className="print-meta">
                    <h4 data-en="Kraft Paper Bag" data-ar="كيس ورق كرافت">Kraft Paper Bag</h4>
                    <p data-en="Eco-friendly kraft paper bags" data-ar="أكياس ورق كرافت صديقة للبيئة">Eco-friendly kraft paper bags</p>
                  </div>
                </div>
              </Link>
              <Link to="/coated-paper-bags" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="packaging">
                  <div className="print-image"><img src={asset('assets/image20.webp')} alt="Coated Paper Bags" /></div>
                  <div className="print-meta">
                    <h4 data-en="Coated Paper Bag" data-ar="كيس ورق مطلي">Coated Paper Bag</h4>
                    <p data-en="Premium coated paper bags" data-ar="أكياس ورق مطلي فاخرة">Premium coated paper bags</p>
                  </div>
                </div>
              </Link>
              <Link to="/calendars" style={{textDecoration: 'none', color: 'inherit'}}>
                <div className="print-card" data-category="calendars">
                  <div className="print-image"><img src={asset('assets/calendars_hero.png')} alt="Calendars" /></div>
                  <div className="print-meta">
                    <h4 data-en="Calendars" data-ar="التقويمات">Calendars</h4>
                    <p data-en="Custom desk and wall calendars" data-ar="تقويمات مكتبية وحائط مخصصة">Custom desk and wall calendars</p>
                  </div>
                </div>
              </Link>
            </ProductBrowser>
          </section>
          {/* Trusted logos */}
          <section className="trusted" id="clients">
            <h3 data-en="Trusted by leading organizations" data-ar="موثوق من قبل المؤسسات الرائدة">Trusted by leading
              organizations</h3>
            <div className="partners-carousel-container">
              <div className="partners-carousel">
                <div className="partner-item"><img src={asset('assets/partner1.png')} alt="Partner 1" /></div>
                <div className="partner-item"><img src={asset('assets/partner2.png')} alt="Partner 2" /></div>
                <div className="partner-item"><img src={asset('assets/partner3.png')} alt="Partner 3" /></div>
                <div className="partner-item"><img src={asset('assets/partner4.png')} alt="Partner 4" /></div>
                <div className="partner-item"><img src={asset('assets/partner5.png')} alt="Partner 5" /></div>
                <div className="partner-item"><img src={asset('assets/partner6.webp')} alt="Partner 6" /></div>
                <div className="partner-item"><img src={asset('assets/partner7.webp')} alt="Partner 7" /></div>
                <div className="partner-item"><img src={asset('assets/partner8.webp')} alt="Partner 8" /></div>
                <div className="partner-item"><img src={asset('assets/partner9.svg')} alt="Partner 9" /></div>
                {/* Duplicate for seamless loop */}
                <div className="partner-item"><img src={asset('assets/partner1.png')} alt="Partner 1" /></div>
                <div className="partner-item"><img src={asset('assets/partner2.png')} alt="Partner 2" /></div>
                <div className="partner-item"><img src={asset('assets/partner3.png')} alt="Partner 3" /></div>
                <div className="partner-item"><img src={asset('assets/partner4.png')} alt="Partner 4" /></div>
                <div className="partner-item"><img src={asset('assets/partner5.png')} alt="Partner 5" /></div>
                <div className="partner-item"><img src={asset('assets/partner6.webp')} alt="Partner 6" /></div>
                <div className="partner-item"><img src={asset('assets/partner7.webp')} alt="Partner 7" /></div>
                <div className="partner-item"><img src={asset('assets/partner8.webp')} alt="Partner 8" /></div>
                <div className="partner-item"><img src={asset('assets/partner9.svg')} alt="Partner 9" /></div>
              </div>
            </div>
          </section>
          <section className="ready-cta" id="quote">
            <h2 data-en="Ready to print?" data-ar="جاهز للطباعة؟">Ready to print?</h2>
            <p data-en="Upload your file and get a quote today." data-ar="قم بتحميل ملفك واحصل على عرض أسعار اليوم.">Upload
              your file and get a quote today.</p>
            <div className="cta-buttons">
              <a className="btn2" href="#products"><span data-en="Get a Quote" data-ar="احصل على عرض أسعار">Get a Quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
              <button className="btn3" onClick={openContact} type="button"><img src={asset('assets/email.svg')} alt="" /><span data-en="Contact Us" data-ar="اتصل بنا">Contact
                  Us</span></button>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default Home;
